import { IVehicle } from "../../interfaces/session/IVehicle";
import { deepFind } from "../../util/helper/deepFind";
import { ICategory } from "../interfaces/category-api.type";

export function computeAndGetParams(category: ICategory, vehicle: IVehicle, url: string) {
  const make = deepFind(vehicle, "make");
  const model = deepFind(vehicle, "model");
  const year = deepFind(vehicle, "year");
  const tier0 = deepFind(category, "tier0");
  const tier1 = deepFind(category, "tier1");
  const tier2 = deepFind(category, "tier2");
  const tier3 = deepFind(category, "tier3");
  if (!tier0 && !url) {
    return new Promise<string>(() => Promise.reject(new Error(`Tier0 is required - ${JSON.stringify(category)} - ${JSON.stringify(vehicle)}`)));
  }
  let params = {};
  if (category.tier0 !== "Tools & Equipment") {
    params = {
      tier0, tier1, tier2, make, model, year, tier3, url,
    };
  } else {
    params = {
      tier0, tier1, tier2, tier3, url,
    };
  }
  return params;
}
